export function createTransactionDetailManager(config) {
    var state = config.state;
    var selectedGeometryId = null;
    var selectedGeometry = null;
    var geometryRequest = null;

    function renderSelectedGeometry(transactionId, geoData) {
        if (state.getSelectedTid() !== transactionId) return;
        var controller = config.getTransactionsController();
        if (controller && geoData && geoData.features && geoData.features.length) {
            controller.renderHighlightData(geoData);
            config.bringDataLayersToFront();
        }
    }

    function loadSelectedGeometry(transactionId) {
        if (selectedGeometryId === transactionId && selectedGeometry) {
            renderSelectedGeometry(transactionId, selectedGeometry);
            return;
        }
        if (selectedGeometryId === transactionId && geometryRequest) return;
        if (geometryRequest) geometryRequest.abort();
        selectedGeometryId = transactionId;
        selectedGeometry = null;
        var request = new AbortController();
        geometryRequest = request;
        fetch('api/geojson?geometry_id=' + encodeURIComponent(transactionId), { signal: request.signal })
            .then(function(response) { if (!response.ok) throw new Error('Geometry request failed'); return response.json(); })
            .then(function(data) {
                if (request.signal.aborted || selectedGeometryId !== transactionId) return;
                if (!data || data.error || !Array.isArray(data.features) || !data.features.length) return;
                selectedGeometry = data;
                renderSelectedGeometry(transactionId, data);
            })
            .catch(function() { /* The selected centroid remains visible on failure. */ })
            .finally(function() { if (geometryRequest === request) geometryRequest = null; });
    }

    function tryHighlightTransactionParcel(transactionId) {
        if (!config.getMap()) return;

        var found = config.highlightTransactionById(transactionId);
        var geoData = config.getLatestGeoData ? config.getLatestGeoData() : null;
        var summary = geoData && (geoData.features || []).some(function(feature) {
            return feature.properties && feature.properties.map_summary === true
                && feature.properties.tran_lokalny_id_iip === transactionId;
        });
        if (summary || selectedGeometryId === transactionId || (!found && config.getLatestGeoData)) {
            loadSelectedGeometry(transactionId);
            return;
        }
        if (found) return;

        var detailCache = state.getDetailCache();
        var detail = detailCache[transactionId];
        if (!detail || !Array.isArray(detail.items)) return;

        var idDzialki = null;
        for (var index = 0; index < detail.items.length; index += 1) {
            if (detail.items[index].id_dzialki) {
                idDzialki = String(detail.items[index].id_dzialki);
                break;
            }
        }

        if (!idDzialki) return;

        fetch(config.BASE_URL + 'api/dzialki?pin_only=1&id_dzialki=' + encodeURIComponent(idDzialki))
            .then(function(response) { return response.json(); })
            .then(function(geoData) {
                if (!geoData || !geoData.features || !geoData.features.length) return;
                if (state.getSelectedTid() !== transactionId) return;

                var transactionsController = config.getTransactionsController();
                var result = transactionsController
                    ? transactionsController.renderHighlightData(geoData)
                    : { found: false, center: null };
                if (!result.found) return;

                config.bringDataLayersToFront();
                if (result.center) {
                    state.setSelectedLatLng(result.center);
                    config.rebuildNearbyLinkIfNeeded();
                }
            })
            .catch(function(err) { console.error('Transaction highlight failed:', err); });
    }

    function fetchTransactionDetail(transactionId) {
        if (!transactionId) return;

        var detailCache = state.getDetailCache();
        if (detailCache[transactionId]) {
            if (state.getSelectedTid() !== transactionId) return;
            config.renderTransactionDetails(detailCache[transactionId]);
            tryHighlightTransactionParcel(transactionId);
            return;
        }

        var abortDetail = state.getAbortDetail();
        if (abortDetail) abortDetail.abort();
        abortDetail = new AbortController();
        state.setAbortDetail(abortDetail);

        fetch('api/detail/' + transactionId, { signal: abortDetail.signal })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (state.getSelectedTid() !== transactionId) return;
                if (data.error) {
                    config.renderDetailsError(data.error);
                    return;
                }
                detailCache[transactionId] = data;
                config.renderTransactionDetails(data);
                tryHighlightTransactionParcel(transactionId);
            })
            .catch(function(err) {
                if (err.name === 'AbortError') return;
                if (state.getSelectedTid() !== transactionId) return;
                config.renderDetailsError('Błąd ładowania');
            });
    }

    return {
        fetchTransactionDetail: fetchTransactionDetail,
        tryHighlightTransactionParcel: tryHighlightTransactionParcel,
    };
}
